<template>
  <div>
    <JunkPage />
  </div>
</template>

<script>
import JunkPage from "../junk/components/JunkPage.vue";
export default {
  components: {
    JunkPage,
  },
};
</script>

<style>
</style>